import { render, staticRenderFns } from "./e-input-payment-type.vue?vue&type=template&id=89bcade8&scoped=true&lang=pug&"
import script from "./e-input-payment-type.vue?vue&type=script&lang=js&"
export * from "./e-input-payment-type.vue?vue&type=script&lang=js&"
import style0 from "./e-input-payment-type.vue?vue&type=style&index=0&id=89bcade8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89bcade8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VTooltip})
